webpackJsonp([11],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	
	var _react = __webpack_require__(3);var _react2 = _interopRequireDefault(_react);
	var _reactDom = __webpack_require__(30);var _reactDom2 = _interopRequireDefault(_reactDom);
	__webpack_require__(109);
	var _Provider = __webpack_require__(179);var _Provider2 = _interopRequireDefault(_Provider);
	var _xReactRouter = __webpack_require__(78);
	var _login = __webpack_require__(408);var _login2 = _interopRequireDefault(_login);
	var _login3 = __webpack_require__(1097);var _login4 = _interopRequireDefault(_login3);
	
	var _global = __webpack_require__(300);var _global2 = _interopRequireDefault(_global);
	
	var _routers = __webpack_require__(68);
	
	var _initializer = __webpack_require__(47);var _initializer2 = _interopRequireDefault(_initializer);
	var _loading = __webpack_require__(23);var _loading2 = _interopRequireDefault(_loading);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };} // initializer
	// 全局
	(0, _initializer2.default)(function () {
	  _reactDom2.default.render(
	  _react2.default.createElement(_Provider2.default, { reducer: _login2.default },
	    _react2.default.createElement(_xReactRouter.Router, { prefix: '/pms' },
	      _react2.default.createElement(_xReactRouter.Route, { path: '/(home)?', component: _routers.Home, preload: true }),
	      _react2.default.createElement(_xReactRouter.Route, { path: '/settings/*', component: _routers.Settings, preload: true }),
	      _react2.default.createElement(_xReactRouter.Route, { path: '/login' },
	        _react2.default.createElement(_login4.default, { hasEpassErr: false, hasEpassErrWithCode: false }),
	        _react2.default.createElement(_global2.default, null)),
	
	      _react2.default.createElement(_xReactRouter.Route, { path: '/findpwd', component: _routers.FindPwd, loading: _loading2.default }))),
	
	
	  document.getElementById('pms'));
	
	}); // Other pages
	/*
	 * PMS登录页
	 */

/***/ }),

/***/ 39:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _extends2 = __webpack_require__(1);var _extends3 = _interopRequireDefault(_extends2);exports.default =
	
	
	
	
	
	
	
	
	
	
	
	
	
	router;var _type = __webpack_require__(2);var _type2 = _interopRequireDefault(_type);var _router = __webpack_require__(96);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function parseParam(param) {if (!param) return {};if ({}.hasOwnProperty.call(param, 'innId')) {return (0, _extends3.default)({}, param, { innId: parseInt(param.innId, 10) });}return param;}function router() {var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _router.parseUrl)(document.location.href);var action = arguments[1];
	  switch (action.type) {
	    case _type2.default.JUMP_TO:
	      return {
	        prevRouter: action.prevRouter,
	        path: action.router.path,
	        param: parseParam(action.router.param),
	        t: action.router.t || state.t || 0 };
	
	    default:
	      return state;}
	
	}

/***/ }),

/***/ 47:
/***/ (function(module, exports) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });exports.default = init;function init(run) {
	  var state = document.readyState;
	  if (state === 'complete' || state === 'interactive') {
	    return run();
	  }
	  if (window.addEventListener) {
	    window.addEventListener('DOMContentLoaded', run);
	  } else {
	    window.attachEvent('onload', run);
	  }
	}

/***/ }),

/***/ 49:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _extends2 = __webpack_require__(1);var _extends3 = _interopRequireDefault(_extends2);var _type = __webpack_require__(2);var _type2 = _interopRequireDefault(_type);
	var _redux = __webpack_require__(4);
	var _ready = __webpack_require__(5);var _ready2 = _interopRequireDefault(_ready);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	function epassportHeight()
	
	{var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { hasEpassErr: false };var action = arguments[1];
	  switch (action.type) {
	    case _type2.default.EPASSPORT_HEIGHT_RESIZE:
	      return (0, _extends3.default)({},
	      state, {
	        hasEpassErr: true,
	        hasEpassErrWithCode: action.code });
	
	    default:
	      return state;}
	
	}
	
	function exportDialogData()
	
	
	
	{var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { display: false, readyState: _ready2.default.UNSET, message: null };var action = arguments[1];
	  switch (action.type) {
	    case _type2.default.EPASSPORT_SHOW_EXPORT_DIALOG:
	      return (0, _extends3.default)({},
	      state, {
	        display: true });
	
	    case _type2.default.EPASSPORT_HIDE_EXPORT_DIALOG:
	      return {
	        display: false,
	        message: null,
	        readyState: _ready2.default.UNSET };
	
	    case _type2.default.EPASSPORT_EXPORT_DATA_LOADING:
	      return (0, _extends3.default)({},
	      state, {
	        readyState: _ready2.default.LOADING });
	
	    case _type2.default.EPASSPORT_EXPORT_DATA_SUCCESS:
	      return (0, _extends3.default)({},
	      state, {
	        readyState: _ready2.default.SUCCESS,
	        display: false });
	
	    case _type2.default.EPASSPORT_EXPORT_DATA_FAIL:
	      return (0, _extends3.default)({},
	      state, {
	        readyState: _ready2.default.FAIL,
	        message: action.error });
	
	    case _type2.default.EPASSPORT_HEIGHT_RESIZE:
	      return (0, _extends3.default)({},
	      state, {
	        hasEpassErr: true,
	        hasEpassErrWithCode: action.code });
	
	    default:
	      return state;}
	
	}exports.default =
	
	(0, _redux.combineReducers)({
	  exportDialogData: exportDialogData,
	  epassportHeight: epassportHeight });

/***/ }),

/***/ 68:
/***/ (function(module, exports) {

	"use strict";Object.defineProperty(exports, "__esModule", { value: true });var _window$routers = window.routers,Home = _window$routers.Home,Dist = _window$routers.Dist,Order = _window$routers.Order,Stat = _window$routers.Stat,Settings = _window$routers.Settings,Other = _window$routers.Other,Login = _window$routers.Login,FindPwd = _window$routers.FindPwd,BindGuide = _window$routers.BindGuide;exports.
	
	Home = Home;exports.Dist = Dist;exports.Order = Order;exports.Stat = Stat;exports.Settings = Settings;exports.Other = Other;exports.Login = Login;exports.FindPwd = FindPwd;exports.BindGuide = BindGuide;

/***/ }),

/***/ 73:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _type = __webpack_require__(2);var _type2 = _interopRequireDefault(_type);
	var _app = __webpack_require__(24);
	var _localStorage = __webpack_require__(72);var _localStorage2 = _interopRequireDefault(_localStorage);
	var _redux = __webpack_require__(4);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	function newUserIntro() {var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _app.INTRO_STEP.OVER;var action = arguments[1];
	  switch (action.type) {
	    case _type2.default.HOTELS_SAVE_SUCCESS:
	      return state < _app.INTRO_STEP.HOTEL_SAVED ? _app.INTRO_STEP.HOTEL_SAVED : state;
	    case _type2.default.ROOMTYPES_SAVE_SUCCESS:
	      return state < _app.INTRO_STEP.ROOMTYPE_SAVED ? _app.INTRO_STEP.ROOMTYPE_SAVED : state;
	    case _type2.default.INTRO_SET_STEP:
	      return action.step;
	    case _type2.default.LOGIN_SUCCESS:
	      // 根据门店数量判断是否显示新用户引导
	      if (action.data && action.data.innCount === 0 && action.data.roleId === 2) {
	        return _app.INTRO_STEP.SHOW_HOTEL_FORM;
	      }
	      return _app.INTRO_STEP.OVER;
	    default:
	      return state;}
	
	}
	
	var otaHomeIntroStep = +_localStorage2.default.getItem('otaHomeIntroStep') || 1;
	function otaHomeIntro() {var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : otaHomeIntroStep;var action = arguments[1];
	  switch (action.type) {
	    case _type2.default.OTA_HOME_INTRO_SET_STEP:
	      _localStorage2.default.setItem('otaHomeIntroStep', action.step);
	      return action.step;
	    case _type2.default.JUMP_TO:{
	        var step = _localStorage2.default.getItem('otaHomeIntroStep');
	        if (!step) {
	          _localStorage2.default.setItem('otaHomeIntroStep', 1);
	          step = 1;
	        }
	        return +step;
	      }
	    default:
	      return state;}
	
	}
	
	var otaTodayIntroStep = +_localStorage2.default.getItem('otaTodayIntroStep') || 1;
	function otaTodayIntro() {var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : otaTodayIntroStep;var action = arguments[1];
	  switch (action.type) {
	    case _type2.default.OTA_TODAY_INTRO_SET_STEP:
	      _localStorage2.default.setItem('otaTodayIntroStep', action.step);
	      return action.step;
	    case _type2.default.JUMP_TO:{
	        var step = _localStorage2.default.getItem('otaTodayIntroStep');
	        if (!step) {
	          _localStorage2.default.setItem('otaTodayIntroStep', 1);
	          step = 1;
	        }
	        return +step;
	      }
	    default:
	      return state;}
	
	}exports.default =
	
	(0, _redux.combineReducers)({
	  newUserIntro: newUserIntro,
	  otaHomeIntro: otaHomeIntro,
	  otaTodayIntro: otaTodayIntro });

/***/ }),

/***/ 74:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _extends2 = __webpack_require__(1);var _extends3 = _interopRequireDefault(_extends2);exports.default =
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	upgrade;var _type = __webpack_require__(2);var _type2 = _interopRequireDefault(_type);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var _store = { percent: 0, received: 0, total: 0, releaseNotes: '', loopDelay: 1000 * 60, isStartDownload: false, show: false, forceUpdate: true, version: '', newVersion: '', ignoreVersion: '', fullpath: '', downloadUrl: '', showBubble: null, webVersion: '3.16.0', showWebUpgradeNotice: false };function checkVersion(newVersion, oldVersion) {if ((undefined) === 'staging') return false;var a1 = newVersion.split('.');var a2 = oldVersion.split('.');for (var i = 0; i < a1.length; i++) {if (+a1[i] > +a2[i]) {return true;}}return false;}function upgrade() {var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _store;var action = arguments[1];
	  switch (action.type) {
	    case _type2.default.INIT_VERSION:
	      return (0, _extends3.default)({},
	      state, {
	        version: action.version,
	        ignoreVersion: action.ignoreVersion || state.ignoreVersion });
	
	    case _type2.default.CHECK_UPGRADE_SUCCESS:{
	        var webRelease = action.data.web_release || {};
	        var clientRelease = action.data;
	        var webVersionUpdate = false;
	        if (state.webVersion) {
	          webVersionUpdate = webRelease.release_notes && checkVersion(webRelease.version, state.webVersion);
	        }
	        return (0, _extends3.default)({},
	        state, {
	          releaseNotes: clientRelease.release_notes,
	          forceUpdate: clientRelease.force_update,
	          newVersion: clientRelease.version,
	          downloadUrl: clientRelease.dl_link,
	          loopDelay: (clientRelease.check_rate > 60 ? clientRelease.check_rate : 60) * 1000,
	          show: !state.show ? clientRelease.version > state.version &&
	          clientRelease.version !== state.ignoreVersion : true,
	          showBubble: state.showBubble === null ? state.version < clientRelease.version :
	          state.showBubble,
	          webVersion: state.webVersion === null ? webRelease.version : state.webVersion,
	          webReleaseNotes: webRelease.release_notes,
	          webVersionUpdate: webVersionUpdate, // 作为后面判断是否显示通知的依据
	          showWebUpgradeNotice: webRelease.version !== state.webVersion && webVersionUpdate });
	
	      }
	    case _type2.default.IGNORE_UPGRADE:
	      return (0, _extends3.default)({},
	      state, {
	        ignoreVersion: action.version,
	        show: false });
	
	    case _type2.default.SHOW_UPGRADE_DIALOG:
	      return (0, _extends3.default)({},
	      state, {
	        show: true });
	
	    case _type2.default.START_DOWNLOAD:
	      return (0, _extends3.default)({},
	      state, {
	        isStartDownload: true });
	
	    case _type2.default.UPGRADE_DOWNLOADING:
	      return (0, _extends3.default)({},
	      state, {
	        percent: action.percent,
	        received: action.received,
	        total: action.total,
	        fullpath: action.fullpath });
	
	    case _type2.default.CLOSE_UPGRADE_BUBBLE:
	      return (0, _extends3.default)({},
	      state, {
	        showBubble: false });
	
	    case _type2.default.JUMP_TO:
	      if (action.prevRouter.path !== action.router.path &&
	      action.router.path.split('/').length === 1 &&
	      state.webVersionUpdate) {
	        return (0, _extends3.default)({},
	        state, {
	          showWebUpgradeNotice: true });
	
	      }
	      return state;
	    case _type2.default.HIDE_WEB_UPGRADE_NOTICE:
	      return (0, _extends3.default)({},
	      state, {
	        showWebUpgradeNotice: false });
	
	    default:
	      return state;}
	
	}

/***/ }),

/***/ 77:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 216:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _entries = __webpack_require__(236);var _entries2 = _interopRequireDefault(_entries);var _getPrototypeOf = __webpack_require__(8);var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);var _classCallCheck2 = __webpack_require__(6);var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);var _createClass2 = __webpack_require__(7);var _createClass3 = _interopRequireDefault(_createClass2);var _possibleConstructorReturn2 = __webpack_require__(10);var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);var _inherits2 = __webpack_require__(9);var _inherits3 = _interopRequireDefault(_inherits2);var _react = __webpack_require__(3);var _react2 = _interopRequireDefault(_react);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var
	
	LoginForm = function (_Component) {(0, _inherits3.default)(LoginForm, _Component);function LoginForm() {(0, _classCallCheck3.default)(this, LoginForm);return (0, _possibleConstructorReturn3.default)(this, (LoginForm.__proto__ || (0, _getPrototypeOf2.default)(LoginForm)).apply(this, arguments));}(0, _createClass3.default)(LoginForm, [{ key: 'componentDidMount', value: function componentDidMount()
	
	
	
	
	
	
	
	
	
	
	    {
	      window.epassportCallback = this.props.redirectCallback;
	    } }, { key: 'componentWillReceiveProps', value: function componentWillReceiveProps(
	    nextProps) {
	      window.epassportCallback = nextProps.redirectCallback;
	    } }, { key: 'render', value: function render()
	    {
	      var epassport = window.serveData.epassport || {};
	      var query = (0, _entries2.default)(this.props.query).reduce(function (result, item) {
	        result.push(item.join('='));
	        return result;
	      }, []).join('&');
	
	      if (query) {
	        query = '?' + query;
	      }
	      var defaultClassName = 'epassport-login-form login-form ' + this.props.className;
	      return (
	        _react2.default.createElement('div', { className: defaultClassName,
	            style: {
	              display: this.props.display } },
	
	
	          _react2.default.createElement('p', { className: 'err-tip', style: { display: this.props.err ? '' : 'none' } },
	            _react2.default.createElement('i', null, '\xD7'),
	            this.props.err || '用户名或密码输入有误，请重新输入！'),
	
	          _react2.default.createElement('iframe', {
	              name: 'epassport',
	              src:
	              epassport.prefix + '/account/unitivelogin?bg_source=4&service=dayin-pms&feconfig=' + (this.props.feconfig || '') + '&continue=' +
	              encodeURIComponent((
	              epassport.redirectUrl || document.location.origin) + '/pms/epassport/token' + query) + '&only_auth=1\n            ' }, '\u7F8E\u56E2\u5546\u5BB6\u767B\u5F55\u5E73\u53F0\u4F7F\u7528\u4E86\u6846\u67B6\u6280\u672F\uFF0C\u4F46\u662F\u60A8\u7684\u6D4F\u89C8\u5668\u4E0D\u652F\u6301\u6846\u67B6\uFF0C\u8BF7\u5347\u7EA7\u60A8\u7684\u6D4F\u89C8\u5668\u4EE5\u4FBF\u6B63\u5E38\u8BBF\u95EE\u3002')));
	
	
	
	
	
	    } }]);return LoginForm;}(_react.Component);LoginForm.cid = '登录';LoginForm.propTypes = { display: _react.PropTypes.string, err: _react.PropTypes.string, query: _react.PropTypes.object, redirectCallback: _react.PropTypes.func, feconfig: _react.PropTypes.string, className: _react.PropTypes.string, hideLoginError: _react.PropTypes.func };exports.default = LoginForm;

/***/ }),

/***/ 226:
[1822, 40, 225, 214, 240],

/***/ 233:
/***/ (function(module, exports) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true }); /**
	                                                                             * 【设置页】常量
	                                                                             */
	var SETTING_TABS = exports.SETTING_TABS = {
	  USER_SETTING: 'account',
	  HOTEL_SETTING: 'hotel',
	  OPERATE_LOG: 'oplog',
	  TC_LOG: 'tcLog',
	  LOCK_LOG: 'locklog',
	  FEATURE_SETTING: 'feature',
	  HELP_CENTER: 'help' };
	
	
	var SETTING_TABS_LIST = exports.SETTING_TABS_LIST = [{
	  name: '门店管理',
	  id: SETTING_TABS.HOTEL_SETTING,
	  act: '查看门店信息' },
	{
	  name: '操作日志',
	  id: SETTING_TABS.OPERATE_LOG,
	  requireInnId: true,
	  disabled: true,
	  act: '查看操作日志' },
	{
	  name: '物理门锁日志',
	  id: SETTING_TABS.TC_LOG,
	  requireInnId: true,
	  disabled: true,
	  act: '查看门锁日志' },
	{
	  name: '门锁日志',
	  id: SETTING_TABS.LOCK_LOG,
	  requireInnId: true,
	  disabled: true,
	  act: '查看门锁日志' },
	{
	  name: '功能设置',
	  cid: '设置-功能设置',
	  id: SETTING_TABS.FEATURE_SETTING,
	  requireInnId: true,
	  disabled: true,
	  act: '功能设置' },
	{
	  name: '帮助中心',
	  cid: '设置-帮助中心',
	  id: SETTING_TABS.HELP_CENTER,
	  requireInnId: true,
	  disabled: true,
	  act: '帮助中心' }];
	
	
	var USER_TABS_LIST = exports.USER_TABS_LIST = [{
	  name: '帐号信息',
	  id: SETTING_TABS.USER_SETTING,
	  act: '查看账号信息' }];

/***/ }),

/***/ 236:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(237), __esModule: true };

/***/ }),

/***/ 237:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(241);
	module.exports = __webpack_require__(29).Object.entries;


/***/ }),

/***/ 241:
[1860, 26, 226],

/***/ 248:
/***/ (function(module, exports) {

	"use strict";Object.defineProperty(exports, "__esModule", { value: true });var LOGIN_CHANNEL = exports.LOGIN_CHANNEL = {
	  EB_INTRO: 1,
	  EB: 2,
	  DINGDANG: 3 };
	
	
	var LOGIN_STATUS = exports.LOGIN_STATUS = {
	  NO_LOGIN: 0,
	  LOGIN: 1,
	  SUCCESS: 2,
	  FAIL: 3,
	  KICK_OFF: 4 };

/***/ }),

/***/ 262:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _type = __webpack_require__(2);var _type2 = _interopRequireDefault(_type);
	var _epassport = __webpack_require__(315);var _epassport2 = _interopRequireDefault(_epassport);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =
	
	{
	  showExportDialog: function showExportDialog() {
	    return {
	      type: _type2.default.EPASSPORT_SHOW_EXPORT_DIALOG };
	
	  },
	  hideExportDialog: function hideExportDialog() {
	    return {
	      type: _type2.default.EPASSPORT_HIDE_EXPORT_DIALOG };
	
	  },
	  startExportData: function startExportData(data) {
	    return function (dispatch) {
	      dispatch({
	        type: _type2.default.EPASSPORT_EXPORT_DATA_LOADING,
	        data: data });
	
	      _epassport2.default.exportData(data).then(function (res) {
	        if (res.status === 0) {
	          dispatch({
	            type: _type2.default.EPASSPORT_EXPORT_DATA_SUCCESS,
	            result: res.data });
	
	          document.location.reload();
	        } else {
	          dispatch({
	            type: _type2.default.EPASSPORT_EXPORT_DATA_FAIL,
	            error: res.message });
	
	        }
	      });
	    };
	  },
	  bindAccount: function bindAccount(id) {
	    return {
	      type: _type2.default.DIST_BIND_EBOOKING_SUCCESS,
	      id: id };
	
	  },
	  heightResizeWithCode: function heightResizeWithCode(code) {
	    return {
	      type: _type2.default.EPASSPORT_HEIGHT_RESIZE,
	      code: code };
	
	  } };

/***/ }),

/***/ 315:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _adapt = __webpack_require__(59);exports.default =
	
	{
	  exportData: function exportData(token) {
	    return (0, _adapt.post)('/inn/initWithEb', { token: token }, {
	      timeout: 30000 });
	
	  } };

/***/ }),

/***/ 387:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _keyMirror = __webpack_require__(35);var _keyMirror2 = _interopRequireDefault(_keyMirror);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =
	
	(0, _keyMirror2.default)({
	  // 用户登录
	  LOGIN_SET_FORM_DATA: null,
	  LOGIN_SUCCESS: null,
	  LOGIN_FAIL: null,
	  LOGIN_HIDE_ERROR: null });

/***/ }),

/***/ 399:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _getPrototypeOf = __webpack_require__(8);var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);var _classCallCheck2 = __webpack_require__(6);var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);var _createClass2 = __webpack_require__(7);var _createClass3 = _interopRequireDefault(_createClass2);var _possibleConstructorReturn2 = __webpack_require__(10);var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);var _inherits2 = __webpack_require__(9);var _inherits3 = _interopRequireDefault(_inherits2);var _react = __webpack_require__(3);var _react2 = _interopRequireDefault(_react);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var
	
	LoginForm = function (_Component) {(0, _inherits3.default)(LoginForm, _Component);function LoginForm() {var _ref;var _temp, _this, _ret;(0, _classCallCheck3.default)(this, LoginForm);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = LoginForm.__proto__ || (0, _getPrototypeOf2.default)(LoginForm)).call.apply(_ref, [this].concat(args))), _this), _this.
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	    onSubmit = function (evt) {
	      evt.preventDefault();
	      _this.props.onLogin();
	    }, _this.
	    changeVal = function (name, value) {
	      _this.props.setFormData(name, value);
	    }, _this.
	    onFindPwd = function (evt) {
	      evt.preventDefault();
	      _this.props.onFindPwd();
	    }, _this.
	    onRegister = function (evt) {
	      evt.preventDefault();
	      _this.props.onRegister();
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);}(0, _createClass3.default)(LoginForm, [{ key: 'componentWillMount', value: function componentWillMount() {window.LXPage(window.serveData.lxData.mobileLogin.id);} }, { key: 'render', value: function render()
	    {var _this2 = this;
	      return (
	        _react2.default.createElement('form', { className: 'login-form',
	            onSubmit: this.onSubmit,
	            style: this.props.style },
	
	          this.props.err ?
	          _react2.default.createElement('p', { className: 'login-tip err-tip' },
	            _react2.default.createElement('i', null, '\xD7'),
	            this.props.err || '用户名或密码输入有误，请重新输入！') :
	          _react2.default.createElement('p', null),
	
	          _react2.default.createElement('label', { className: 'login-input' },
	            _react2.default.createElement('i', { className: 'prefix pms-font-guest-2' }),
	            _react2.default.createElement('input', {
	              type: 'text',
	              placeholder: this.props.usernamePlaceholder || '手机号',
	              autoFocus: true,
	              value: this.props.username,
	              onChange: function onChange(e) {return _this2.changeVal('username', e.target.value.trim());} }),
	
	            this.props.username !== '' && _react2.default.createElement('i', { className: 'suffix', onClick: function onClick() {return _this2.changeVal('username', '');} }, '\xD7')),
	
	          _react2.default.createElement('label', { className: 'login-input' },
	            _react2.default.createElement('i', { className: 'prefix pms-font-lock' }),
	            _react2.default.createElement('input', {
	              type: 'password',
	              placeholder: this.props.passwordPlaceholder || '密码',
	              value: this.props.password,
	              onChange: function onChange(e) {return _this2.changeVal('password', e.target.value.trim());} }),
	
	            this.props.password !== '' && _react2.default.createElement('i', { className: 'suffix', onClick: function onClick() {return _this2.changeVal('password', '');} }, '\xD7')),
	
	          _react2.default.createElement('button', {
	              type: 'submit',
	              className: 'btn btn-primary login-btn',
	              'data-cid': this.props.cid,
	              'data-act': '\u767B\u5F55',
	              style: { position: this.props.needVerify ? 'relative' : '', marginTop: this.props.needVerify ? '180px' : '' } },
	            this.props.loginText || '登录'),
	          typeof this.props.onRegister === 'function' && _react2.default.createElement('a', {
	              href: '/pms/register',
	              className: 'btn btn-link login-register',
	              'data-cid': this.props.cid,
	              'data-act': '\u65B0\u7528\u6237\u6CE8\u518C' }, '\u65B0\u7528\u6237\u6CE8\u518C'),
	
	          typeof this.props.onFindPwd === 'function' && _react2.default.createElement('a', {
	              href: '',
	              className: 'btn btn-link forget-passwd',
	              onClick: this.onFindPwd,
	              'data-cid': this.props.cid,
	              'data-act': '\u627E\u56DE\u5BC6\u7801' }, '\u5FD8\u8BB0\u5BC6\u7801')));
	
	
	
	    } }]);return LoginForm;}(_react.Component);LoginForm.cid = '登录';LoginForm.propTypes = { style: _react.PropTypes.object, cid: _react.PropTypes.string, username: _react.PropTypes.string, usernamePlaceholder: _react.PropTypes.string, password: _react.PropTypes.string, passwordPlaceholder: _react.PropTypes.string, loginText: _react.PropTypes.string, err: _react.PropTypes.string, succMsg: _react.PropTypes.string, setFormData: _react.PropTypes.func, onLogin: _react.PropTypes.func, onFindPwd: _react.PropTypes.func, onRegister: _react.PropTypes.func, needVerify: _react.PropTypes.bool };exports.default = LoginForm;

/***/ }),

/***/ 407:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _extends2 = __webpack_require__(1);var _extends3 = _interopRequireDefault(_extends2);exports.
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	loginFormData = loginFormData;var _login = __webpack_require__(387);var _login2 = _interopRequireDefault(_login);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var loginDefaultState = { username: '', password: '', mempasswd: false, err: null, timestamp: -1, bid: '', bind: false, channel: null, innCount: null, localEmpty: true, remoteEmpty: true, userId: null, needVerify: false, yodaChecked: true, succMsg: '' };function loginFormData() {var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : loginDefaultState;var action = arguments[1];
	  switch (action.type) {
	    case _login2.default.LOGIN_SET_FORM_DATA:
	      return (0, _extends3.default)({},
	      state,
	      action.data);
	
	    case _login2.default.LOGIN_SUCCESS:
	      return (0, _extends3.default)({},
	      state, {
	        logon: true },
	      action.data, {
	        timestamp: Date.now() });
	
	    case _login2.default.LOGIN_FAIL:
	      return (0, _extends3.default)({},
	      action.data, {
	        err: action.message,
	        timestamp: Date.now() });
	
	    case _login2.default.LOGIN_HIDE_ERROR:
	      return (0, _extends3.default)({},
	      state, {
	        err: null,
	        timestamp: -1 });
	
	    default:
	      return state;}
	
	}

/***/ }),

/***/ 408:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _login = __webpack_require__(407);
	var _intro = __webpack_require__(73);var _intro2 = _interopRequireDefault(_intro);
	var _upgrade = __webpack_require__(74);var _upgrade2 = _interopRequireDefault(_upgrade);
	var _router = __webpack_require__(39);var _router2 = _interopRequireDefault(_router);
	var _epassport = __webpack_require__(49);var _epassport2 = _interopRequireDefault(_epassport);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =
	
	{
	  loginFormData: _login.loginFormData,
	  intro: _intro2.default,
	  upgrade: _upgrade2.default,
	  router: _router2.default,
	  epassport: _epassport2.default };

/***/ }),

/***/ 828:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });exports.
	
	setDsStatus = setDsStatus;var _type = __webpack_require__(2);var _type2 = _interopRequireDefault(_type);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function setDsStatus(data) {
	  return {
	    type: _type2.default.DS_SET,
	    status: data };
	
	}

/***/ }),

/***/ 1097:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _extends2 = __webpack_require__(1);var _extends3 = _interopRequireDefault(_extends2);var _defineProperty2 = __webpack_require__(21);var _defineProperty3 = _interopRequireDefault(_defineProperty2);var _getPrototypeOf = __webpack_require__(8);var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);var _classCallCheck2 = __webpack_require__(6);var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);var _createClass2 = __webpack_require__(7);var _createClass3 = _interopRequireDefault(_createClass2);var _possibleConstructorReturn2 = __webpack_require__(10);var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);var _inherits2 = __webpack_require__(9);var _inherits3 = _interopRequireDefault(_inherits2);var _react = __webpack_require__(3);var _react2 = _interopRequireDefault(_react);
	var _redux = __webpack_require__(4);
	var _reactRedux = __webpack_require__(15);
	var _user = __webpack_require__(270);var _user2 = _interopRequireDefault(_user);
	var _app = __webpack_require__(24);
	var _settings = __webpack_require__(233);
	var _account = __webpack_require__(248);
	var _user3 = __webpack_require__(295);
	var _app2 = __webpack_require__(22);
	var _epassport = __webpack_require__(262);var _epassport2 = _interopRequireDefault(_epassport);
	var _dsStatus = __webpack_require__(828);
	var _loginForm = __webpack_require__(399);var _loginForm2 = _interopRequireDefault(_loginForm);
	var _upgrade = __webpack_require__(539);var _upgrade2 = _interopRequireDefault(_upgrade);
	var _epassport3 = __webpack_require__(216);var _epassport4 = _interopRequireDefault(_epassport3);
	var _xReactRouter = __webpack_require__(78);
	var _utils = __webpack_require__(46);var _utils2 = _interopRequireDefault(_utils);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var
	
	queryToJson = _utils2.default.queryToJson;var
	
	Login = function (_Component) {(0, _inherits3.default)(Login, _Component);function Login() {(0, _classCallCheck3.default)(this, Login);return (0, _possibleConstructorReturn3.default)(this, (Login.__proto__ || (0, _getPrototypeOf2.default)(Login)).apply(this, arguments));}(0, _createClass3.default)(Login, [{ key: 'componentWillMount', value: function componentWillMount()
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	    {
	      _user2.default.resetAuth();
	      this.props.setDsStatus(0);
	      window.PmsBridge && window.PmsBridge.events.trigger('__logout__');
	      if (window.location.search) {
	        var queryParam = queryToJson(window.location.search.slice(1));
	        queryParam.channel = _account.LOGIN_CHANNEL.EB;
	        queryParam.token ? this.props.login(queryParam) : queryParam;
	        queryParam.phoneNum ? this.props.setLoginFormData({ username: queryParam.phoneNum }) : '';
	      }
	    } }, { key: 'componentWillReceiveProps', value: function componentWillReceiveProps(
	
	    nextProps) {
	      if (nextProps.logon && nextProps.timestamp !== this.props.timestamp) {
	        // 新用户引导，自动跳转至门店设置页
	        if (nextProps.intro === _app.INTRO_STEP.SHOW_HOTEL_FORM) {
	          this.props.jumpTo({ path: 'settings/' + _settings.SETTING_TABS.HOTEL_SETTING });
	        } else {
	          this.props.jumpTo({ path: 'home' });
	        }
	        this.props.hideLoginError();
	      }
	    } }, { key: 'changeLoginType', value: function changeLoginType(
	    loginType) {
	      this.props.hideLoginError();
	      this.props.jumpTo({
	        path: 'login',
	        param: loginType ? { loginType: loginType } : {} });
	
	    } }, { key: 'emptyFunc', value: function emptyFunc()
	    {} }, { key: 'renderMain', value: function renderMain()
	    {var _this2 = this;
	      var isEpassport = this.props.loginType !== 'mobile';var _props =
	      this.props,username = _props.username,password = _props.password,err = _props.err,succMsg = _props.succMsg;
	      var props = this.props;
	      var switchBtnToTop = void 0;
	      if (props.hasEpassErrWithCode) {
	        switchBtnToTop = '-2px';
	      } else if (props.hasEpassErr) {
	        switchBtnToTop = '-68px';
	      } else {
	        switchBtnToTop = '-118px';
	      }
	      return (
	        _react2.default.createElement('div', { className: 'login-main' },
	          _react2.default.createElement(_loginForm2.default, {
	            cid: Login.cid,
	            username: username,
	            password: password,
	            err: err,
	            succMsg: succMsg,
	            setFormData: function setFormData(name, value) {return _this2.props.setLoginFormData((0, _defineProperty3.default)({}, name, value));},
	            onLogin: function onLogin() {
	              props.login({ username: username, password: password, channel: _account.LOGIN_CHANNEL.DINGDANG, mempasswd: true });
	            }
	            // onRegister={() => props.jumpTo({
	            //   path: 'register',
	            // })}
	            // onFindPwd={() => props.jumpTo({
	            //   path: 'findpwd',
	            // })}
	            , needVerify: this.props.needVerify,
	            style: { display: !isEpassport ? 'block' : 'none' } })));
	
	
	
	    } }, { key: 'render', value: function render()
	
	    {var _this3 = this;
	      var that = this;
	      window.onmessage = function (msg) {
	        var msgData = msg.data;
	        if (!msgData || msgData[0] !== '{') return;
	        try {
	          var result = JSON.parse(msgData);
	          var epassHeight = result.height;
	          if (result.type === 'EPASSPORT_HEIGHT_RESIZE') {
	            if (_this3.props.loginType !== 'mobile') {
	              if (epassHeight > 250 && epassHeight < 300) {
	                that.props.heightResizeWithCode();
	              } else if (epassHeight >= 300) {
	                that.props.heightResizeWithCode(true);
	              }
	            }
	          }
	        } catch (e) {
	          window.logger.error(e);
	        }
	      };
	      return (
	        _react2.default.createElement('div', null,
	          _react2.default.createElement('div', { className: 'login-content' },
	            _react2.default.createElement('div', { className: 'login-panel' },
	              _react2.default.createElement('header', null,
	                _react2.default.createElement('h1', { className: 'login-title' },
	                  _react2.default.createElement('img', { src: __webpack_require__(77), title: '\u91D1\u5757\u7BA1\u5BB6', alt: '\u91D1\u5757\u7BA1\u5BB6' }))),
	
	
	              this.renderMain(),
	              _react2.default.createElement('div', { className: 'phone', style: { bottom: this.props.needVerify ? '0' : '50px' } },
	                _react2.default.createElement('p', null, '\u4FBF\u6377\u9AD8\u6548\u7684\u9152\u5E97\u7BA1\u7406\u7CFB\u7EDF,\u63D0\u9AD8\u9152\u5E97\u5BA2\u623F\u7BA1\u7406\u901F\u5EA6')),
	
	
	
	              _react2.default.createElement('footer', { style: { bottom: this.props.needVerify ? '-40px' : '10px' } },
	                _react2.default.createElement('p', null, '\u7248\u6743\u4FE1\u606F Copyright \xA9')))),
	
	
	
	          _react2.default.createElement(_upgrade2.default, null)));
	
	
	    } }]);return Login;}(_react.Component);Login.cid = '登录';Login.propTypes = { username: _react.PropTypes.string, password: _react.PropTypes.string, err: _react.PropTypes.string, succMsg: _react.PropTypes.string, timestamp: _react.PropTypes.number, loginType: _react.PropTypes.string, login: _react.PropTypes.func, setLoginFormData: _react.PropTypes.func, hideLoginError: _react.PropTypes.func, jumpTo: _react.PropTypes.func, loginFail: _react.PropTypes.func, hasEpassErr: _react.PropTypes.bool, hasEpassErrWithCode: _react.PropTypes.bool, heightResizeWithCode: _react.PropTypes.func, needVerify: _react.PropTypes.bool, setDsStatus: _react.PropTypes.func };
	
	
	function mapStateToProps(_ref) {var loginFormData = _ref.loginFormData,intro = _ref.intro,router = _ref.router,epassport = _ref.epassport,hotels = _ref.hotels;
	  return (0, _extends3.default)({}, loginFormData, {
	    intro: intro.newUserIntro,
	    loginType: router.param.loginType,
	    hasEpassErr: epassport.epassportHeight.hasEpassErr,
	    hasEpassErrWithCode: epassport.epassportHeight.hasEpassErrWithCode,
	    hotels: hotels });
	
	}
	
	function mapDispatchToProps(dispatch) {
	  return (0, _redux.bindActionCreators)((0, _extends3.default)({
	    login: _user3.login,
	    setLoginFormData: _user3.setLoginFormData,
	    hideLoginError: _user3.hideLoginError,
	    jumpTo: _app2.jumpTo,
	    loginFail: _user3.loginFail },
	  _epassport2.default, {
	    setDsStatus: _dsStatus.setDsStatus }),
	  dispatch);
	}exports.default =
	
	(0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Login);

/***/ })

});


// WEBPACK FOOTER //
// js/login-qing-44703f5ca41c7e77857d.js